/* POSTED — My Posted requests.
   Address-change and cancellation forms send their request to POSTED HQ through the store's app proxy
   (/apps/posted/*). Shopify signs the call and adds the logged-in customer, so nothing here can be spoofed. */
(() => {
  const fill = (text, values) => text.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, key) => (key in values ? values[key] : ''));

  const setMessage = (form, text, tone) => {
    const box = form.querySelector('[data-posted-req-message]');
    if (!box) return;
    box.textContent = text || '';
    box.hidden = !text;
    box.dataset.tone = tone || 'error';
  };

  const send = async (url, body) => {
    const response = await fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    let data = {};
    try {
      data = await response.json();
    } catch (error) {
      data = {};
    }
    return { status: response.status, ...data };
  };

  const loadEstimate = async (form) => {
    const line = form.querySelector('[data-posted-req-estimate]');
    const submit = form.querySelector('[data-posted-req-submit]');
    if (!line || form.dataset.estimated === 'true') return;
    line.textContent = form.dataset.estLoading;
    submit.disabled = true;
    try {
      const response = await fetch(`${form.dataset.estimateUrl}?ref=${encodeURIComponent(form.dataset.ref)}`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      const data = await response.json();
      if (response.status === 401) throw new Error('signin');
      if (!response.ok || !data.ok) throw new Error('estimate');
      const rule = data.onOrBeforeCutoff ? form.dataset.estBefore : form.dataset.estAfter;
      let result = form.dataset.estNone;
      if (data.refundableCount === 1) {
        result = fill(form.dataset.estAmountOne, { amount: data.estimatedRefundAed });
      } else if (data.refundableCount > 1) {
        result = fill(form.dataset.estAmount, { amount: data.estimatedRefundAed, count: data.refundableCount });
      }
      line.textContent = `${fill(rule, { day: data.cutoffDay })} ${result}`;
      form.dataset.estimated = 'true';
      submit.disabled = false;
    } catch (error) {
      line.textContent = '';
      setMessage(form, error.message === 'signin' ? form.dataset.errSignin : form.dataset.errGeneric);
    }
  };

  const showDone = (form, text) => {
    form.querySelectorAll('[data-posted-req-fields]').forEach((node) => {
      node.hidden = true;
    });
    form.querySelector('[data-posted-req-submit]').hidden = true;
    form.querySelector('.posted-req__lead').hidden = true;
    setMessage(form, text, 'done');
    form.dataset.done = 'true';
  };

  const validateAddress = (form, values) => {
    if (!values.fullName || !values.mobile || !values.emirate || !values.streetAddress) return form.dataset.errRequired;
    if (values.googleMapsUrl && !/^https:\/\/\S+$/i.test(values.googleMapsUrl)) return form.dataset.errMaps;
    const changed = Array.from(form.querySelectorAll('input, textarea')).some((field) => field.value.trim() !== field.defaultValue.trim());
    const selectChanged = Array.from(form.querySelectorAll('select')).some((select) => !select.options[select.selectedIndex].defaultSelected);
    return changed || selectChanged ? '' : form.dataset.errNochange;
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-posted-open]');
    if (opener) {
      const dialog = document.getElementById(opener.getAttribute('aria-controls'));
      if (!dialog || typeof dialog.showModal !== 'function') return;
      dialog.showModal();
      const form = dialog.querySelector('form');
      if (form && form.dataset.postedRequest === 'cancel') loadEstimate(form);
      return;
    }
    const closer = event.target.closest('[data-posted-close]');
    if (closer) {
      const dialog = closer.closest('dialog');
      const done = dialog.querySelector('form').dataset.done === 'true';
      dialog.close();
      if (done) window.location.reload();
      return;
    }
    // Clicking the dimmed backdrop closes the dialog.
    if (event.target instanceof HTMLDialogElement && event.target.classList.contains('posted-req')) {
      const done = event.target.querySelector('form').dataset.done === 'true';
      event.target.close();
      if (done) window.location.reload();
    }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[data-posted-request]');
    if (!form) return;
    event.preventDefault();
    const submit = form.querySelector('[data-posted-req-submit]');
    const kind = form.dataset.postedRequest;
    const values = Object.fromEntries(new FormData(form).entries());
    Object.keys(values).forEach((key) => {
      values[key] = String(values[key]).trim();
    });

    setMessage(form, '');
    if (kind === 'address') {
      const problem = validateAddress(form, values);
      if (problem) return setMessage(form, problem);
    } else if (!values.reason) {
      return setMessage(form, form.dataset.errRequired);
    }

    submit.disabled = true;
    submit.querySelector('span').textContent = form.dataset.sending;
    try {
      const result = await send(form.dataset.url, { ref: form.dataset.ref, ...values });
      if (result.ok) {
        const extra = kind === 'address' && result.appliesTo === 'next' ? ` ${form.dataset.next}` : '';
        showDone(form, form.dataset.done + extra);
        return;
      }
      setMessage(form, result.status === 401 ? form.dataset.errSignin : form.dataset.errGeneric);
    } catch (error) {
      setMessage(form, form.dataset.errGeneric);
    }
    submit.disabled = false;
    submit.querySelector('span').textContent = submit.dataset.label;
  });
})();
